import { render, staticRenderFns } from "./ProfessionIndex.vue?vue&type=template&id=087e684c"
import script from "./ProfessionIndex.vue?vue&type=script&lang=js"
export * from "./ProfessionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports